import TicketCreateThreatDetails from './TicketCreateThreatDetails';

export default TicketCreateThreatDetails;
